/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-23 18:47:49
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import EnumOperates from 'src/enums/enumOperates';
 import { Integer } from 'src/types/base';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import InputNumber from 'src/types/iview/InputNumber';
//  import DeclareMaintenanceApi, { DeclareMaintenanceDOI } from './api/declareMaintenanceApi';
import AlarmSearchTestApi, {AlarmSearchTestDOI} from './api/testApi'
 import { createNamespace } from 'src/util/bem';
 import EnumMaintenanceAuditStatus from 'src/enums/enumMaintenanceAuditStatus';
 import { DateTimeUtil } from 'src/util/dateTimeUtil';
 import  DatePicker from 'src/types/iview/DatePicker';
 import EnumAlarmType from 'src/enums/enumAlarmType';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';

export namespace alarmSearchVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        timestamp: Integer;
        device_id: Integer;
        type: Integer;
    }
}

let uid = 1;

@Component
class AlarmSearchModal extends Vue.Component<alarmSearchVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: alarmSearchVOI.FormDataI = {
        timestamp: null,
        device_id: null,
        type:null,
    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        debugger
        let res;
        this.loading = true;
        this.formData.timestamp = DateTimeUtil.getSecondFromIviewDate(this.formData.timestamp)
        let params: AlarmSearchTestDOI.FormDataI = {
            ...this.formData,
        };
        res = await AlarmSearchTestApi.add(params);
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success('成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    genKey() {
        return uid++;
    }
    add(index: number) {
        this.formData.operationalSite.splice(index + 1, 0, { deviceId: null, components: [], key: this.genKey() });
    }
    sub(index: number) {
        this.formData.operationalSite.splice(index, 1);
    }
    async mounted() {
    }
    render(h) {
        return (
            <Modal title={'新增报警'} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="报警时间" prop="timestamp" required type="date" style="display: inline-block;width:45%">
                        <DatePicker editable placeholder="请选择" type="datetime" v-model={this.formData.timestamp} />
                    </form-item>
                    <form-item
                        label="报警站点"
                        prop="device_id"
                        required
                        type="number"
                        style="width:45%"
                    >
                        <EntitySelect type={EnumEntity.Station.getId()} v-model={this.formData.device_id} />
                    </form-item>
                    <form-item label="报警类型" prop="type" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumAlarmType.getList() as any} v-model={this.formData.type} placeholder="请输入" />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertAlarmSearchModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<alarmSearchVOI.PropsI>(AlarmSearchModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}